// config.js

// Determina se siamo in locale o produzione
const IS_LOCAL = process.env.REACT_APP_IS_LOCAL === "true";

// Configurazione endpoints
const API_ENDPOINT = IS_LOCAL
  ? "https://server.misteryinvestigation.it"
  : "https://server.misteryinvestigation.it";

const WEBSOCKET_ENDPOINT = IS_LOCAL
  ? "wss://server.misteryinvestigation.it"
  : "wss://server.misteryinvestigation.it";

// Log per debug (solo in sviluppo)
if (process.env.NODE_ENV === "development") {
  console.log("🔧 Config:", {
    IS_LOCAL,
    API_ENDPOINT,
    WEBSOCKET_ENDPOINT,
  });
}

module.exports = {
  API_ENDPOINT,
  WEBSOCKET_ENDPOINT,
  IS_LOCAL,
};
